import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { shopTarifierungVHV } from './shopTarifierungVHV';
import { watchVersicherungssummenTrigger } from './versicherungssummenSaga';
import { watchWertsachensummenTrigger } from './wertsachensummenSaga';
import { streckenTarifierungVHV } from './streckenTarifierungVHV';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchproduktlinienSaga } from './produktlinienSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { handleVhvNavigationToAngebotSaga } from './handleVhvNavigationToAngebotSaga';
import { updateRisikoortAfterLoadAzamSaga } from './updateRisikoortAfterLoadAzamSaga';
import { extremWetterSchutzVorbelegenSaga } from './extremWetterSchutzVorbelegenSaga';
import { watchResetAdressdatenRequested } from './resetAdressdatenSaga';

export function* rootSaga() {
  yield all([
    watchAntragsnummerRequested(),
    shopTarifierungVHV(),
    watchVorschlagdatenChanged(),
    watchVersicherungssummenTrigger(),
    watchWertsachensummenTrigger(),
    streckenTarifierungVHV(),
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchproduktlinienSaga(),
    watchDruckdatenChanged(),
    watchInDashboardUebernehmenSaga(),
    watchQuoteDB(),
    watchVorbelegungRequested(),
    handleVhvNavigationToAngebotSaga(),
    updateRisikoortAfterLoadAzamSaga(),
    extremWetterSchutzVorbelegenSaga(),
    watchResetAdressdatenRequested(),
  ]);
}
